module.exports = __webpack_public_path__ + "img/send-order.8b9d74f5.svg";